import { render } from "./EditPatientComponent.vue?vue&type=template&id=1d0ee308"
import script from "./EditPatientComponent.vue?vue&type=script&lang=js"
export * from "./EditPatientComponent.vue?vue&type=script&lang=js"

import "./EditPatientComponent.vue?vue&type=style&index=0&id=1d0ee308&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__